import SelectFromCisButtons from '../components/Controls/SelectFromCisButtons.vue';
export default {
  components: {
    SelectFromCisButtons
  }
};
